<template>
  <d-navbar-nav class="border-left flex-row">
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-nowrap px-3" v-d-toggle.user-actions>
        <div class="user-avatar rounded-circle mr-2" >
          {{ userInitials }}
        </div>
        <span class="d-none d-md-inline-block">{{ getUser.email }}</span>
      </a>
      <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
        <d-dropdown-item href="#" class="text-danger" >
          <span @click="logout"><i class="material-icons text-danger">&#xE879;</i> Wyloguj</span>
        </d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'NavBarNav',
        computed: {
            ...mapGetters([
                'getUser',
            ]),
            userInitials(){
                return this.getUser.name && this.getUser.surname ? this.getUser.name.charAt(0) + this.getUser.surname.charAt(0) : '??';
            }
        },
        methods: {
            ...mapActions([
                'logoutUser'
            ]),
            logout(){
                this.logoutUser();
            }
        }
    };
</script>
<style>
  .nav-link:hover {
    cursor: pointer;
  }
  .user-avatar.rounded-circle.mr-2 {
    background: #006fe6;
    height: 2.5rem;
    line-height: 2.5rem;
    text-align: center;
    color: white;
    display: inline-block;
    width: 2.5rem;
  }
</style>
